export default __webpack_public_path__ + "assets/telegram-black-icon.609c29cf.svg";